import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../../../Data/ReduxViewModels/ImportedWorksheet/actions';
import { Field, Message } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ImportTestListDropdown } from '../../WorksheetDropdowns/ImportTestListDropdown';
import { IWorksheetComponent } from '../../types';

interface IWorksheetTestSearchParams extends IWorksheetComponent {
  selectedTestSectionId: string;
  importPropertyName?: string;
  queryParams?: any;
  selectionFields?: React.ReactNode;
  label?: string;
  emptyListMessage?: string;
  searchImmediately?: boolean;
  autoSelectSingleOption?: boolean;
}

let WorksheetTestSearch: React.FC<IWorksheetTestSearchParams> = ({
  selectedTestSectionId,
  queryParams = undefined,
  selectionFields = undefined,
  importPropertyName = undefined,
  label = undefined,
  emptyListMessage = undefined,
  searchImmediately = false,
  autoSelectSingleOption = false,
}) => {
  const dispatch = useDispatch();
  const selectedTestId = useSelector((s: any) => s.importedWorksheet[selectedTestSectionId]?.selectedTest?.Id);
  const selectedSampleId = useSelector((s) => s.importedWorksheet[selectedTestSectionId]?.selectedSample?.SampleId);

  const testSelectionTestId = useSelector((s) => s.importedWorksheet[selectedTestSectionId]?.testSelection?.Id);
  const testSelectionLabel = useSelector((s) => s.importedWorksheet[selectedTestSectionId]?.testSelection?.label);
  const [isEmptyList, setIsEmptyList] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    dispatch(
      actions.updateImportedWorksheetSearch(selectedTestSectionId, {
        importFromThisSample: false,
        importFromSpecificSample: false,
        importFromSpecificTest: true,
      })
    );
  });
  const onTestSelectionChange = (e: { data: any }) => {
    dispatch(
      actions.updateImportedWorksheetSearch(selectedTestSectionId, {
        testSelection:
          e.data.value && e.data.value.value ? { Id: e.data.value.value, label: e.data.value.label } : null,
      })
    );
  };

  const onTestListChange = (data: any) => {
    if (!data?.list?.some((s: any) => s.value === testSelectionTestId)) {
      dispatch(
        actions.updateImportedWorksheetSearch(selectedTestSectionId, {
          testSelection: null,
        })
      );
    }

    if (!!emptyListMessage) {
      setIsEmptyList(data?.list?.length === 0);
    }
  };

  return (
    <>
      {selectionFields}
      <Field
        label={label ?? 'Sample ID'}
        input={<ImportTestListDropdown />}
        value={
          testSelectionTestId
            ? { value: testSelectionTestId ?? selectedTestId, label: testSelectionLabel ?? selectedSampleId }
            : null
        }
        queryParams={queryParams}
        importPropertyName={importPropertyName}
        onChange={onTestSelectionChange}
        onListChange={onTestListChange}
        searchImmediately={searchImmediately}
        autoSelectSingleOption={autoSelectSingleOption}
      />
      {!!emptyListMessage && !!isEmptyList && <Message info>{emptyListMessage}</Message>}
    </>
  );
};

WorksheetTestSearch = withInjectedProps(WorksheetTestSearch);

export { WorksheetTestSearch };
export type { IWorksheetTestSearchParams };
export default WorksheetTestSearch;
